var menuHandler = {
    duration: 300,
    el: null,
    item: null,
    items: null,
    els: null,
    attr: null,
    inner: null,
    inners: null,
    allInners: null,
    innersParent: null,
    innersItems: null,
    innersInnersItems: null,
    slickModel: null,

    init: function (element) {
        this.el = $(element);
        this.item = this.el.closest('.menu__item');
        this.items = this.item.siblings('.menu__item');
        this.els = this.items.find('[data-link]');
        this.attr = this.el.attr('data-link');
        this.inner = $('[data-inner="' + this.attr + '"]');
        this.inners = this.inner.siblings('[data-inner]');
        this.allInners = $('[data-inner]');
        this.innersParent = this.item.parents('[data-inner]');
        this.innersItems = this.inners.find('.is_active');
        this.innersInnersItems = this.inner.find('.is_active');
        this.slickModel = this.inner.children('.inner__list--model');
    },

    deactivateItems: function () {
        this.els.removeClass('is_active');
        this.items.removeClass('is_active');
        this.inners.stop().slideUp(this.duration, () => {
            $(this).removeAttr('style').removeClass('is_active');
        });
        this.allInners.stop().slideUp(this.duration, () => {
            $(this).removeAttr('style').removeClass('is_active');
        });
    },

    activateItem: function () {
        this.el.addClass('is_active');
        this.item.addClass('is_active');
        this.innersParent.stop().slideDown(this.duration, () => {
            $(this).removeAttr('style').addClass('is_active');
            $('[data-inner]').find('.slick-slider').slick('destroy');
        });
        this.inner.stop().slideDown(this.duration, () => {
            $(this).removeAttr('style').addClass('is_active');
            this.initializeSlick();
        });
    },

    initializeSlick: function () {
        if (window.innerWidth < 1024 && this.slickModel.length) {
            if (!this.slickModel.hasClass('slick-slider')) {
                this.slickModel.slick({
                    arrows: false,
                    dots: false,
                    slidesToShow: 3,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 568,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                });
            }
        } else if (this.slickModel.length && this.slickModel.hasClass('slick-slider')) {
            this.slickModel.slick('destroy');
        }
    },

    handleScroll: function () {
        var elTop = this.el.offset().top,
            menu = $('.menu'),
            calc = elTop - menu.offset().top;

        $('.header__bottom').animate({ scrollTop: calc }, this.duration);
        console.log('calc ==== ' + calc);
    },

    handleClick: function (e) {
        e.stopPropagation();
        e.preventDefault();
        this.init(e.currentTarget);

        if (!this.el.hasClass('is_active')) {
            this.deactivateItems();
            this.activateItem();
            this.innersItems.removeClass('is_active');

            if (window.innerWidth < 1024) {
                setTimeout(() => this.handleScroll(), this.duration);
            }
        } else {
            this.el.removeClass('is_active');
            this.item.removeClass('is_active');
            this.inners.stop().slideUp(this.duration, () => {
                $(this).removeAttr('style').removeClass('is_active');
            });
            this.inner.stop().slideUp(this.duration, () => {
                $(this).removeAttr('style').removeClass('is_active');
                if (this.slickModel.length) {
                    this.slickModel.each(function () {
                        if ($(this).hasClass('slick-slider')) {
                            $(this).slick('destroy');
                        }
                    });
                }
            });
            this.innersInnersItems.removeClass('is_active');
        }
    }
};

$(document).ready(function () {
    $(document).on('click', '[data-link]', function (e) {
        menuHandler.handleClick(e);
    });

    $('.burger__address').on('click', function (e) {
        e.stopPropagation(); // предотвращает выполнение события на родителе
    });

    $('.burger').on('click', function () {
        if (!$('body').hasClass('overflow')) {
            $('body').addClass('overflow');
        } else {
            $('body').removeClass('overflow');
        }
        if (!$('.header').hasClass('is_active')) {
            $('.header').addClass('is_active');
        } else {
            $('.header').removeClass('is_active');
        }
        if (!$(this).hasClass('is_active')) {
            $(this).addClass('is_active');
        } else {
            $(this).removeClass('is_active');
        }
        if (!$('.search').hasClass('is_active')) {
            $('.search').stop().delay(300).slideDown(300, function () {
                $(this).removeAttr('style').addClass('is_active');
            });
            setTimeout(function () {
                $('.search').find('input').eq(0).focus();
            }, 600);
        } else {
            $('.search').stop().slideUp(300, function () {
                $(this).removeAttr('style').removeClass('is_active');
                $(this).find('.input').val('')
            });
        }
        if (!$('.menu').hasClass('is_active')) {
            $('.menu').stop().slideDown(300, function () {
                $(this).removeAttr('style').addClass('is_active');
            });
            setTimeout(function () {
                $('.header__logo').addClass('open').eq(0);
            }, 200);
        } else {
            $('.menu').stop().slideUp(300, function () {
                $(this).removeAttr('style').removeClass('is_active');
            });
            setTimeout(function () {
                $('.header__logo').removeClass('open').eq(0);
            }, 200);
        }
    });
});
